import { Space } from "antd"
import { Button, CountDown, OtpInputField, Text, Title, notification } from "components/common"
import { SvgIcResetPassword } from "components/svg"
import { getDeviceInoHash, performEncryption } from "configs/utils"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { useVerifyMobileOTPMutation } from "../api"
import styles from "../index.module.less"

const OPTVerificationFlow = ({ challengeUserToLogin, isLoadingChallenge, setCurrentState, userState }) => {
  const { t } = useTranslation()
  const [verifyMobileOTP, { isLoading: isLoadingMobileOTP }] = useVerifyMobileOTPMutation()
  const [resetTimer, setResetTimer] = useState(Date.now() + 120 * 1000)
  const [mobileOTP, setMobileOTP] = useState()

  const handleMobileOTPVerification = async () => {
    const response = await verifyMobileOTP({
      a: performEncryption(userState?.uuid),
      b: getDeviceInoHash(false, userState?.uuid),
      token: mobileOTP,
    })
    if (response?.error) {
      notification.error({ message: response?.error?.message })
    } else if (response?.data?.otpVerified) {
      notification.success({ message: t("OTP verified successfully") })
      challengeUserToLogin(userState?.uuid)
    }
    setMobileOTP(null)
  }
  return (
    <Space direction="vertical" size={32} className="text-center w-100">
      <div>
        <Space size={6} className="w-100 mbe-12" align="baseline" style={{ justifyContent: "center" }}>
          <Title level={2} className=" mbe-0 ">
            {t("Verify OTP")}
          </Title>
          <SvgIcResetPassword />
        </Space>

        <Text block type="secondary">
          {t("An OTP has been sent to") + userState?.cell + ". " + t("Please enter the OTP to login")}
        </Text>
      </div>
      <div>
        <OtpInputField
          isDisabled={isLoadingMobileOTP}
          otp={mobileOTP}
          setOtp={setMobileOTP}
          index={6}
          customStyle={{
            width: 54,
            height: 54,
            fontSize: "18px",
          }}
        />
        <Space size={0}>
          <Button
            type="link"
            disabled={!!resetTimer ? true : false}
            onClick={() => {
              challengeUserToLogin(userState?.uuid, false, true)
              setResetTimer(Date.now() + 120 * 1000)
              setMobileOTP(null)
              setCurrentState("default")
            }}
            loading={isLoadingChallenge}
            text={t("Resend Code")}
            className="p-8"
            icon="IoRefresh"
          />

          <CountDown
            value={resetTimer}
            onFinish={() => {
              setResetTimer()
            }}
            format="mm:ss"
            className={styles.countDown}
          />
        </Space>
      </div>

      <Button
        type="primary"
        size="large"
        text={t("Submit")}
        onClick={() => {
          handleMobileOTPVerification()
        }}
        loading={isLoadingMobileOTP}
        block
      />
    </Space>
  )
}
export default OPTVerificationFlow
